import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  success: false,
  error: null,
};

const sendOtpReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEND_OTP_START:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case types.SEND_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.SEND_OTP_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default sendOtpReducer;
